import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import ComparingChart from "../../../../components/help/ComparingChart.tsx";
import {Link} from "react-router-dom";
import Routing from "../../../../Routing.ts";

const questions: Question[] = [
    {
        question: "Hvad er latency?",
        answer: <p>
            Latency (latenstid) er den tid, det tager for data at rejse fra ét punkt til et andet i et netværk.
            Med andre ord er det forsinkelsen mellem afsendelsen af en forespørgsel og modtagelsen af et svar.
            Det måles typisk i millisekunder (ms) og har stor betydning for, hvor hurtigt og responsivt et netværk føles, især i realtidsapplikationer &ndash; så når du enten gamer, streamer eller foretager video-opkald.
            Hvis en forbindelse har lav latency, så er det rigtig godt, da hastigheden er hurtig, hvorimod jo højere latency, des langsommere er internettet og der kan forekomme forsinkelser.
        </p>
    },
    {
        question: "Hvorfor er der forskellige priser på fibernet?",
        answer: <p>
            Prisen på fibernet varierer alt efter hvor du bor henne i Danmark.
            Det skyldes, at fiber-infrastrukturen ejes af forskellige energi- og teleselskaber rundt om i landet, så det er forskellige fra adresse til adresse, hvem der udbyder fibernettet.
            Hvis du vil se den pris, som du kan få på netop din adresse, kan du <Link
                to={Routing.Order}
                rel={'nofollow'}
            >slå den op her</Link>.
        </p>
    },
    {
        question: "Hvilket internet kan jeg få?",
        answer: <p>
            Den bedste internetløsning til dig kommer an på, hvad du bruger dit internet til samt hvor du bor.
            Det internet du kan få fra os, kan du tjekke hurtigst muligt, ved at <Link
                to={Routing.Order}
                rel={'nofollow'}
            >lave et adresseopslag</Link>.
        </p>
    }
]

export default function CompareInternetArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article article--connect">
                    <div className="paragraph">
                        <p>
                            Vi har samlet et overblik over de internetløsninger, som vi udbyder samt hvilke forskelle og ligheder, som de har.
                            På den måde kan du sammenligne de forskellige internetforbindelser med hinanden, for at finde den bedste internetløsning til dig.
                            Vi dækker alt fra teknologi, pris og hastighed.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <ComparingChart className={'comparing-chart--internet'}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    <p>Fibernet</p>
                                </th>
                                <th>
                                    <p>5G-internet</p>
                                </th>
                                <th>
                                    <p>Internet via kabel-tv (coax)</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th><p>Teknologi</p></th>
                                <td>
                                    <p>
                                        Fiberoptiske kabler, der sender data ved lysets hastighed
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Trådløs forbindelse via mobilnetværk
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Koaksialkabler lavet af kobber brugt til kabel-tv, typisk via antenne&shy;stik
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Download-hastighed</p></th>
                                <td>
                                    <p>
                                        100-1000 Mbit
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        100-1000 Mbit
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        100-1000 Mbit
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Upload-hastighed</p></th>
                                <td>
                                    <p>
                                        100-1000 Mbit
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        5-100 Mbit
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        60-500 Mbit
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Stabilitet</p></th>
                                <td>
                                    <p>
                                        Meget høj, med minimal risiko for udfald
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Moderat til høj, afhængig af dækning og netværks&shy;belastning
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Generelt høj, men kan påvirkes af lokal netværks&shy;belastning
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Teknikerbesøg</p></th>
                                <td>
                                    <p>
                                        Nogen gange
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Aldrig
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Nogen gange
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Samme pris i hele Danmark</p></th>
                                <td>
                                    <p>
                                        Nej
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Nej
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Tilgængelighed</p></th>
                                <td>
                                    <p>
                                        Stort set hele landet<br/>
                                        <Link to={Routing.Broadband.CoverageMap + "?cmf=fiber"}>(Se&nbsp;dækningskort)</Link>
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Stort set hele landet<br/>
                                        <Link to={Routing.Broadband.CoverageMap + "?cmf=mbb"}>(Se&nbsp;dækningskort)</Link>
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Høj i byer og bynære områder<br/>
                                        <Link to={Routing.Broadband.CoverageMap + "?cmf=coax"}>(Se&nbsp;dækningskort)</Link>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Inklusiv lånerouter</p></th>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>Tag router med i sommerhus</p></th>
                                <td>
                                    <p>
                                        Nej
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Nej
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>God til gaming</p></th>
                                <td>
                                    <p>
                                        Ja (bedst)
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>God til streaming</p></th>
                                <td>
                                    <p>
                                        Ja (bedst)
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <th><p>God til surfing</p></th>
                                <td>
                                    <p>
                                        Ja (bedst)
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                                <td>
                                    <p>
                                        Ja
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </ComparingChart>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er forskellen på 5G mobilt bredbånd og fiber bredbånd?</h2>
                        <p>
                            Forskellen ligger i, hvordan internettet bliver leveret samt kvalitet og hastighed.
                        </p>
                        <p>
                            <Link to={Routing.Broadband.TDC5G}>5G-bredbånd</Link> er en form for trådløs internet teknologi, der bruger 5G-mobilnetværket til at levere en internetforbindelse.
                            Med 5G-bredbånd modtager man internet via en 5G-router, som opfanger signalet fra en 5G-mast og dermed opretter et wifi-netværk i hjemmet.
                            Det kræver derfor ingen kabler, blot en router med et SIM-kort og et strømstik, før man er online og kan bruge internettet.
                            Fra man har bestilt, er dette altså den hurtigste måde at komme online på.
                        </p>
                        <p>
                            Ved <Link to={Routing.Broadband.Fiber}>fibernet</Link>, går forbindelsen fra en internetudbyder direkte til ens bolig via fiberkabler som bliver koblet til en ud- og indvendig fiberboks på boligen, som så bliver koblet til en router, som dernæst distribuerer internet til hjemmet.
                            Det kræver altså en <Link to={"/hjaelp/bestilling/fiber-installation"}>fibernetinstallation</Link>, medmindre det allerede er blevet etableret på adressen.
                            Dette er en lidt mere tidskrævende proces til sammenligning med 5G-internet.
                        </p>
                        <p>
                            5G har til gengæld en lavere upload-hastighed til sammenligning med fiber, men de kan opnå nogenlunde samme download-hastighed.
                            Fibernet har også en hurtigere og mere stabil svartid, som gør det til en hurtigere forbindelse end 5G.
                            Du kan nemlig få en 1000/1000 forbindelse med fiber til sammenligning med <Link to={Routing.Broadband.TDC5G}>5G-internet</Link>, hvor du højst kan få en 1000/100 forbindelse.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Fordele ved fibernet</h2>
                        <p>
                            Fibernet er en moderne teknologi, som leverer lynhurtigt internet via optiske kabler, som ligger i jorden.
                            Det er det bedste og mest stabile internet, man kan få, da fiberoptiske kabler er meget mindre påvirket af elektrisk &ldquo;støj&rdquo;, vejrforhold eller overbelastning på netværket, som f.eks. mobilt bredbånd, som sender data i luften via radiosignaler.
                        </p>
                        <p>
                            Fiber fungerer rigtig godt til f.eks. gaming og streaming, hvor der skal sendes meget data frem og tilbage.
                            Da der er langt lavere latency (latens) på fibernet vs. 5G og coax, så fungerer denne forbindelse bedst til gaming, så du ikke risikerer at få forsinkelser i dit spil, og får den bedste oplevelse.
                        </p>
                        <p>
                            Fiber er også en rigtig god løsning til husholdninger, hvor der er mange mennesker og enheder, som er online på samme tid og bruger meget data.
                            Med fiber får du en gnidningsfri oplevelse med dit internet.
                        </p>
                        <p>
                            Infrastrukturen på fiber er også fremtidssikret, da den kan håndtere langt højere datamængder end f.eks. kobberkabler, som coax er bygget på.
                            Det betyder, at fiber ville kunne følge med det stigende internetforbrug og krav, uden de store behov for opgraderinger.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Ulemper ved fibernet</h2>
                        <p>
                            Der er typisk installationsomkostninger forbundet til fibernet, da det ikke er alle adresser, som har fået ført fiberkablerne, som ligger ude i vejen, ind til boligen endnu.
                            Vi har dog ofte kampagner på fibernet, hvor vi dækker fiberinstallation omkostningerne, så slå altid din adresse op for at se, hvad vi kan tilbyde dig.
                        </p>
                        <p>
                            Der kan forekomme ekstra omkostninger, hvis du ønsker fiberboksen placeret et andet sted eller der skal graves ekstra.
                            Du kan læse om alt vedrørende <Link to={"/hjaelp/bestilling/fiber-installation"}>praktik og omkostninger til fiberinstallation her</Link>.
                            Ikke desto mindre, er det en omkostning, som kan være værd at betale for at sikre det bedste internet, som man kan få.
                        </p>
                        <p>
                            Processen fra du har købt et fiberprodukt til du er online, kan variere alt efter din adresse.
                            Det skyldes hovedsageligt ovenstående gravearbejde og praktikaliteter vedrørende installationen af dit fiber.
                            Processen afhænger også af, hvilken netværksleverandør som kommer til at levere dit fiber samt hvilke interne installationer, du evt. allerede måtte have.
                            Alt dette kan du læse mere om i <Link to={"/hjaelp/bestilling/fiber-installation"}>artiklen om fiberinstallation</Link>.
                        </p>
                        <p>
                            Det er ikke alle adresser i Danmark, som kan få fibernet, da der ikke er gravet fiberkabler ned i jorden alle steder.
                            Det er for det meste landområder, hvor der ikke er gravet fiber ned endnu, men det bliver gravet ned løbende.
                            <Link
                                to={Routing.Order}
                                rel={'nofollow'}
                            >Tjek altid din adresse</Link> for at se, hvad du har mulighed for at få.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Fiber vs. coax</h2>
                        <p>
                            <Link to={Routing.Broadband.Fiber}>Fibernet</Link> og <Link to={Routing.Broadband.Coax}>coax</Link> (bredbånd leveret gennem kabel-tv-stik) er begge kablede internetforbindelser, dog bygget på forskellige teknologier.
                            Fibernet leverer internet i lysets hastighed via optiske kabler lavet af glasfiber, hvor coax leverer internet via kobberkabler.
                            Teknologien har en afgørende betydning for, hvor hurtigt data bliver sendt og dermed hvor hurtigt, de to typer internet er.
                        </p>
                        <p>
                            Med fibernet kan du få en 1000/1000 Mbit forbindelse, hvorimod at du højst kan få en 1000/500 Mbit forbindelse på coax.
                            Det vil sige, at begge forbindelser kan nå op til 1000 Mbit i download, men det er kun fiber, der kan nå 1000 Mbit i upload.
                            Derudover har fiber lavere latency (latens), altså svartid, end coax, hvilket gør overførsler en tand hurtigere.
                        </p>
                        <p>
                            Vi kan levere fibernet i det meste af landet, men det er mere begrænset med coax, som hovedsageligt kan leveres i Region Hovedstaden samt andre storbyer.
                            Hvis du er i tvivl, om hvad du kan få af internet, så slå altid din adresse op.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvor hurtigt internet har jeg brug for?</h2>
                        <p>
                            Desto mere du bruger dit internet og des flere enheder, som du har koblet til dit wifi, des flere Mbit har du reelt set brug for.
                        </p>
                        <p>
                            Hvis en i husstanden gamer, vil vi altid anbefale fibernet, da der nærmest ingen forsinkelser er på data, hvilket man godt kan risikere med mobilt bredbånd og coax.
                            Man kan dog sagtens bruge mobilt bredbånd og coax til gaming, men den bedste gaming oplevelse, får man med fibernet.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <h2>FAQ</h2>
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "navn-og-kode-til-wifi",
                        "name": "Hvor ser jeg mit navn og kode til wifi?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4- og 5 GHz"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "netvaerkskanaler",
                        "name": "Netværkskanaler"
                    }
                ]}
            />
        </>
    )
}
